import React from 'react'
import InSectionThree from '../../components/InSectionThree'

const fintechServices = [
   {
      title: 'Academic Institutions',
      image: '/assets/svg/industries/education/01-Academics.svg',
      description:
         'Provide state-of-the-art eLearning solutions to training facilities, colleges, institutions, and schools. Our in-house platforms provide tailored, dynamic, and captivating learning experiences that improve retention of information. With intuitive performance tracking, curriculum management, and smooth integrations, streamline educational processes, bridge learning gaps, and realize effective student results.',
   },
   {
      title: 'Corporate & Enterprises',
      image: '/assets/svg/industries/education/02-Corporate.svg',
      description:
         'Improve staff training and advancement with flexible eLearning systems customized for business requirements. Provide engaging onboarding, skills development, and compliance training initiatives. Make use of performance analytics to measure employee advancement, increase efficiency, and promote ongoing improvement.',
   },
   {
      title: 'EdTech Providers',
      image: '/assets/svg/industries/education/03-EdTech.svg',
      description:
         'Power your EdTech company with scalable, feature-rich eLearning solutions. Interactive course modules to adaptive learning algorithms, our solutions enable you to provide immersive learning experiences. Enable smooth material delivery, track student development, and apply data-driven insights to improve efficacy and engagement.',
   },
   {
      title: 'Nonprofit Organizations',
      image: '/assets/svg/industries/education/04-Nonprofit.svg',
      description:
         'Empower your organization with accessible, scalable eLearning solutions built for impact. Provide interactive training programs, knowledge-sharing portals, and certification courses. Enhance learner engagement while efficiently managing content delivery and progress tracking.',
   },
   {
      title: 'Healthcare & Medical Institutions',
      image: '/assets/svg/industries/education/05-Healthcare.svg',
      description:
         'Transform healthcare education with tailored eLearning solutions for medical facilities, hospitals, and healthcare professionals. Provide engaging compliance, patient care, and medical procedure courses. Leverage real-time testing and certification programs to guarantee staff competence and improve patient outcomes.',
   },
   {
      title: 'Mass Market & Public Platforms',
      image: '/assets/svg/industries/education/06-Mass_Market.svg',
      description:
         'Engage wider audiences with adaptable eLearning platforms tailored for mass distribution. From high-volume course deployments to subscription models, our solutions support effortless content delivery, automated testing, and real-time analytics to achieve maximum reach and impact.',
   },
];

function FintechSectionThree() {
   return (
      <section className="industries-bg-image">
         <div className="container">
            <h2 className="text-center cs-text-secondary tech_title section_heading_title mb-3">
               Tailored eLearning Software Solutions for Every Sector
            </h2>
            <p className="section_desc cs-text-secondary mb-0">
               From digital banking to wealth management, we specialize in
               crafting innovative FinTech solutions that drive business growth.
               As a trusted FinTech app development company, we design
               cutting-edge financial technology services that streamline
               operations, enhance security, and improve customer experiences.
               Our tailored solutions cover the entire financial spectrum,
               ensuring impactful and scalable business transformation.
            </p>
         </div>
         <div className="position-relative">
            <InSectionThree itemData={fintechServices} />
         </div>
      </section>
   )
}

export default FintechSectionThree
